<div class="templates-container">
  <sh-json-formatter-renderer
    #jsonFormatterRenderer
    [params]="params"
    class="json-formatter"
  ></sh-json-formatter-renderer>

  <mat-icon class="search-icon" (click)="searchLogsByTemplate()">search</mat-icon>
</div>
